/* Barre d'achat collante — gl. Genere par collant_kit.py, ne pas editer a la main. */
(function () {
  var BARRE = document.querySelector('[data-gl-collant]');
  if (!BARRE) return;
  var SEUIL = parseInt(BARRE.getAttribute('data-seuil'), 10) || 600;
  var bouton = BARRE.querySelector('[data-gl-collant-achat]');
  var vrai = document.querySelector('.product-form__submit, button[name="add"]');

  // Inutile de doubler le bouton quand le vrai est deja sous les yeux.
  var vraiVisible = false;
  if (vrai && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (e) { vraiVisible = e[0].isIntersecting; peindre(); },
      { rootMargin: '-80px 0px -80px 0px' }).observe(vrai);
  }

  // Le pied de page est le dernier bloc de la page : la barre s'efface des qu'il arrive.
  var piedVisible = false;
  var pied = document.querySelector('.gl-pied');
  if (pied && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (e) { piedVisible = e[0].isIntersecting; peindre(); })
      .observe(pied);
  }

  var dernier = 0;
  function peindre() {
    var y = window.scrollY || document.documentElement.scrollTop;
    var montre = y > SEUIL && !vraiVisible && !piedVisible && y >= dernier - 4;
    BARRE.classList.toggle('est-visible', montre);
    BARRE.setAttribute('aria-hidden', montre ? 'false' : 'true');
    dernier = y;
  }
  var enAttente = false;
  window.addEventListener('scroll', function () {
    if (enAttente) return;
    enAttente = true;
    requestAnimationFrame(function () { peindre(); enAttente = false; });
  }, { passive: true });
  peindre();

  // Le bouton de la barre clique le vrai bouton : toute la mecanique
  // (offre quantite, tiroir panier) reste au meme endroit.
  if (bouton) bouton.addEventListener('click', function () {
    var b = document.querySelector('.product-form__submit, button[name="add"]');
    if (!b) return;
    b.scrollIntoView({ block: 'center', behavior: 'auto' });
    b.click();
  });
})();
